import { AuthenticatedLayout } from "../../../../layouts";
import { FC } from "react";
import { InCollectionTransacitons } from "../../../../components/DirectDeposit/Transactions/InCollection";

export interface IInCollectionTransacitonsPage { }

export const InCollectionTransacitonsPage: FC<IInCollectionTransacitonsPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="In Collection"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<InCollectionTransacitons />}
		/>
	);
};
